import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BodyL, DisplayL, HeadlineXL } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  @media ${tabletAndAbove} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
  }
`;

const Cell = styled.div<{ noBorder?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--double-and-a-half-unit) 0;
  border-bottom: solid 1px rgba(var(--c-rgb-white), 0.4);
  gap: calc(2 * var(--double-and-a-half-unit));
  @media ${tabletAndAbove} {
    padding: var(--double-and-a-half-unit) var(--double-and-a-half-unit) 0;
    aspect-ratio: 1;
    border-bottom: none;
    ${({ noBorder }) =>
      !noBorder
        ? 'border-left: solid 1px rgba(var( --c-rgb-white), 0.4);'
        : 'padding-left:0'}
  }
`;
const Title = styled(HeadlineXL)`
  padding-top: calc(4 * var(--double-and-a-half-unit));
`;

const Figure = styled(DisplayL)`
  @media ${tabletAndAbove} {
    word-break: break-word;
    padding-top: calc(4 * var(--double-and-a-half-unit));
  }
`;

const Category = styled(BodyL)`
  @media ${tabletAndAbove} {
    padding-bottom: var(--double-and-a-half-unit);
    border-bottom: solid 1px rgba(var(--c-rgb-white), 0.4);
  }
`;

export const Figures = () => {
  return (
    <Grid>
      <Cell noBorder>
        <Title brand color="var(--c-pink-600)">
          <FormattedMessage
            id="figures.title"
            defaultMessage="Sorare by the numbers"
          />
        </Title>
      </Cell>
      <Cell>
        <Figure brand color="var(--c-white)">
          3M
        </Figure>
        <Category color="var(--c-nd-700-opaque)">
          <FormattedMessage id="figures.users" defaultMessage="Users" />
        </Category>
      </Cell>
      <Cell>
        <Figure brand color="var(--c-white)">
          350 +
        </Figure>
        <Category color="var(--c-nd-700-opaque)">
          <FormattedMessage id="figures.partners" defaultMessage="Partners" />
        </Category>
      </Cell>
      <Cell noBorder>
        <Figure brand color="var(--c-white)">
          $769m
        </Figure>
        <Category color="var(--c-nd-700-opaque)">
          <FormattedMessage
            id="figures.fundraising"
            defaultMessage="Fundraising"
          />
        </Category>
      </Cell>
      <Cell>
        <Figure brand color="var(--c-white)">
          180 +
        </Figure>
        <Category color="var(--c-nd-700-opaque)">
          <FormattedMessage id="figures.markets" defaultMessage="Markets" />
        </Category>
      </Cell>
      <Cell>
        <Figure brand color="var(--c-white)">
          160
        </Figure>
        <Category color="var(--c-nd-700-opaque)">
          <FormattedMessage id="figures.employees" defaultMessage="Employees" />
        </Category>
      </Cell>
    </Grid>
  );
};
